export const Inverti = () => {
  return (
    <section className="centered-section" style={{ marginTop: "6rem" }}>
      <span
        className="horizontal gap-8"
        style={{
          color: "white",
          marginInline: "auto",
          width: "fit-content",
        }}
      >
        <span className="linea-negra"></span>
        <p className="datos-upper-text">Invertí en innovación</p>
        <span className="linea-negra"></span>
      </span>
      <p
        className="section-title"
        style={{
          marginInline: "auto",
          textAlign: "center",
          margin: "2rem 0px",
          maxWidth: 800,
        }}
      >
        ¿Estás listo para sumarte a algo distinto?
      </p>

      <p className="centered-section-subtitle">
        Acá vas a encontrar un equipo con ganas, productos que hacen la
        diferencia y una comunidad que crece con datos, decisiones y tecnología.
      </p>
    </section>
  );
};
